import { useEffect, useState } from "react";

const enterKey = 13;

const useAccessibleSubmit = (
    value: string,
    onSubmit: (value: string, onError?: () => void) => void,
    cartLoadedTime?: number,
    canAddMulti?: boolean,
    multipleSaleQty?: number,
) => {
    const [stateValue, setValue] = useState(value);
    const changeHandler = (event: any) => {
        setValue(event.currentTarget.value);
    };

    const inc = () => {
        setValue(prev => {
            const current = Number(prev) || 0;
            const incrementBy = canAddMulti ? multipleSaleQty || 1 : 1;
            return String(current + incrementBy);
        });
    };

    const dec = () => {
        setValue(prev => {
            const current = Number(prev) || 0;
            const decrementBy = canAddMulti ? multipleSaleQty || 1 : 1;
            const newValue = current - decrementBy;

            if (newValue <= 0) {
                return "0";
            }

            return String(newValue);
        });
    };
    const [isOnSubmitCalled, setIsOnSubmitCalled] = useState(false);
    const callOnSubmitSafety = (value: string) => {
        if (!isOnSubmitCalled) {
            setIsOnSubmitCalled(true);
            onSubmit(value, errorHandler);
        }
    };

    const keyDownHandler = (event: any) => {
        if (event.keyCode === enterKey) {
            event.stopPropagation();
            callOnSubmitSafety(stateValue);
        }
    };

    const blurHandler = () => {
        if (value !== String(stateValue)) {
            callOnSubmitSafety(stateValue);
        }
    };

    const errorHandler = () => {
        setIsOnSubmitCalled(false);
    };

    useEffect(() => {
        setValue(value);
        setIsOnSubmitCalled(false);
    }, [value, cartLoadedTime]);

    return {
        value: stateValue,
        changeHandler,
        keyDownHandler,
        blurHandler,
        inc,
        dec,
    };
};

export default useAccessibleSubmit;
